import dynamic from "next/dynamic";
import Theme from "../components/Theme";
import Hero from "../components/organisms/common/Hero";
import People from "../components/organisms/common/People";
import WideCTA from "../components/organisms/common/WideCTA";
import AppStorage from "../components/AppStorage";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../styles/cssinjs/helpers/variables.js";
const TpWidget = dynamic(() => import("../components/atoms/document/TpWidget"));
const PricingPlanWithTitle = dynamic(() =>
  import("../components/organisms/common/PricingPlanWithTitle")
);
const CTA = dynamic(() => import("../components/organisms/common/CTA"));
const BoxShadowCard = dynamic(() =>
  import("../components/organisms/common/BoxShadowCard")
);

export async function getStaticProps({ locale }) {
  let allData = {};
  // Page Route
  const route = "tour";

  // Fetch data for respective pages
  const headerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/header.json`
  );

  const footerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/footer.json`
  );

  const pricingResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/pricing.json`
  );

  const marketingResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/others/${route}/marketing.json`
  );

  const contentResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/others/${route}/content.json`
  );

  // Catch Error
  if (marketingResponse.status === 404 || contentResponse.status === 404) {
    return {
      notFound: true,
    };
  }

  // Convert
  allData.header = await headerResponse.json();
  allData.footer = await footerResponse.json();
  allData.pricing = await pricingResponse.json();
  allData.marketing = await marketingResponse.json();
  allData.content = await contentResponse.json();

  // Wrap
  const header = {
    header: allData.header,
  };
  const footer = {
    footer: allData.footer,
  };
  const pricing = {
    pricing: allData.pricing,
  };

  // Combine all data
  const data = await {
    ...header,
    ...footer,
    ...pricing,
    ...allData.marketing,
    ...allData.content,
  };
  // Return to the component
  return {
    props: {
      data,
    },
  };
}

export default function Tour({ data, nonce }) {
  const { seo, header, footer, pricing, content } = data;
  return (
    <Theme
      header={header}
      footer={footer}
      seo={seo}
      nonce={nonce}
      className="pricing-layout tour-landing-page"
    >
      <AppStorage pageName={`Tour Page`} />
      <Hero data={content.hero} />
      <section className="container lg:mt-10 md:mt-10">
        <h2 className="text-xl lg:text-center">{content.tourCards.title}</h2>
        <BoxShadowCard
          data={content.tourCards.list}
          colCount={3}
          hasHover={true}
          className="lg:mt-10 md:mt-5 md:mr-0 md:ml-0"
        />
      </section>
      <CTA data={content.cta} className="lg:pt-20 md:pt-10 bg-offset-bottom" />
      <PricingPlanWithTitle
        heading={content.pricingPlan}
        pricing={pricing}
        initialPlanType="annual-billing-plan"
        className="bg-light lg:pb-15 lg:pt-20 md:pt-10"
      />
      <People className="bg-light" />
      <WideCTA data={content.wideCTA} />
      <style global jsx>{`
        @media (max-width: ${viewport.tablet.sm}) {
          .tour-landing-page .hero--default {
            padding-bottom: 0px !important;
          }
          .tour-landing-page .hero--default.has-align-top figure {
            margin-top: 80px !important;
          }
        }
      `}</style>
      <TpWidget />
    </Theme>
  );
}
